export class GeneralConstants {
  public static readonly MaxPlayerCount: number = 16;
  public static readonly PlayerNameMaxLength: number = 16;
  public static readonly GameNameMaxLength: number = 16;
}
